import lodash from "lodash";
import { createFieldDate, createFieldSelect } from "../../../components/input/template-builder/template-builder.logic";
import { createColumnDate, createColumnInput } from "../../../components/table/c-table.logic";
import i18n from "../../../i18n";
import store from "../../../store";
import { conditionFormChecker, putField } from "../../../utils/form";

export const callUser = ({ searchQuery }) => {
    const where = [{ name: "isActive", type: "Boolean", operator: "=", value: true }];
    if (searchQuery) {
        where.push({ name: "fullNameTh", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/security/user/search", {
            criteria: {
                select: ["id", "version", "fullNameTh"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "fullNameTh", type: "ASC" }],
                children: []
            }
        })
        .then(page => page.data);
};

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.user.fullNameTh"),
            dataIndex: "refInstead.fullNameTh",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.userInstead.startDate"),
            dataIndex: "startDate",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.userInstead.endDate"),
            dataIndex: "endDate",
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refInstead`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.userInstead.refInstead"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refInstead,
                            "onUpdate:value": value => (model.refInstead = value),
                            disabled: viewOnly,
                            list: callUser,
                            optLabel: "fullNameTh"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.fullNameTh`) }
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}startDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.userInstead.startDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.startDate, "onUpdate:value": value => (model.startDate = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}endDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.userInstead.endDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.endDate, "onUpdate:value": value => (model.endDate = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            })
        ]
    });
};
